import { getField, updateField } from 'vuex-map-fields';
import { UserApi, VersionApi } from '../../../services/api';

const getUser = () => ({
    id: null,
    name: '',
    username: '',
    email: '',
    phone: '',
    roleId: null,
    accountId: null,
    status: false,
    account: {},
});

export default {
    namespaced: true,
    state: () => ({
        user: getUser(),
        authorization: '',
        permissions: [],
        menuInactive: true,
        showAccountWarning: false,
        loadingCursor: false,
        vetCustomer: null,
        appVersions: [],
    }),
    getters: {
        getField,
        isTrial: (state) => !!((state.user.account?.statusId === 6) && state.user.account?.dueDate),
        accountDueDate: (state) => state.user.account?.dueDate,
        accountId: (state) => state.user.accountId,
        vetCustomer: (state) => state.vetCustomer,
        isVetAccount: (state) => state.user.account?.isVet,
        permissions: (state) => [
            ...state.permissions,
            ...(state?.vetCustomer?.permissions || [])
        ],
        appVersion: (state) => state.appVersions[0]?.name,
    },
    mutations: {
        setUser(state, user) {
            state.user = user;
        },
        setAuthorization(state, authorization) {
            state.authorization = authorization;
        },
        setPermissions(state, permissions) {
            state.permissions = permissions;
        },
        setShowAccountWarning(state, showAccountWarning) {
            state.showAccountWarning = showAccountWarning;
        },
        setLoadingCursor(state, value) {
            state.loadingCursor = value;
        },
        setVetCustomer(state, value) {
            state.vetCustomer = value;
        },
        setAppVersions(state, value) {
            state.appVersions = value;
        },
        updateField,
    },
    actions: {
        setSession({ commit }, { accessToken, user, permissions }) {
            localStorage.setItem('Authorization', accessToken);
            localStorage.setItem('User', JSON.stringify(user));
            localStorage.setItem('Permissions', JSON.stringify(permissions));
            commit('setUser', user);
            commit('setAuthorization', accessToken);
            commit('setPermissions', permissions);
            localStorage.removeItem('VetCustomer');
        },
        setUser({ commit }, user) {
            localStorage.setItem('User', JSON.stringify(user));
            commit('setUser', user);
        },
        setShowAccountWarning({ commit }, user) {
            const showAccountWarning = (
                user?.account?.dueDate
                && (user?.account?.statusId === 2 || user?.account?.statusId === 6)
            );
            commit('setShowAccountWarning', showAccountWarning);
        },
        async loadSession({ commit, state }) {
            const authorization = localStorage.getItem('Authorization');
            const user = localStorage.getItem('User');
            const permissions = localStorage.getItem('Permissions');
            if (user) {
                commit('setUser', JSON.parse(user));
            }
            if (permissions) {
                commit('setPermissions', JSON.parse(permissions));
            }
            if (authorization) {
                commit('setAuthorization', authorization);
            }
            if (localStorage.getItem('VetCustomer')) {
                commit('setVetCustomer', JSON.parse(localStorage.getItem('VetCustomer')));
            }
            if (state.user && state.user.account) {
                const versionResponse = await VersionApi.fetch();
                commit('setAppVersions', versionResponse.results);

                const permissions = await UserApi.fetchPermissions();
                commit('setPermissions', permissions);
                localStorage.setItem('Permissions', JSON.stringify(permissions));
            }
        },
        logout({ commit }) {
            commit('setUser', getUser());
            commit('setAuthorization', '');
            commit('setPermissions', []);
            commit('setVetCustomer', null);
            localStorage.removeItem('Authorization');
            localStorage.removeItem('User');
            localStorage.removeItem('Permissions');
            localStorage.removeItem('VetCustomer');
            localStorage.removeItem('preferences.calcChildBirth');
        },
        setLoadingCursor({ commit }, value) {
            commit('setLoadingCursor', value);
        },
        setVetCustomer({ commit }, value) {
            commit('setVetCustomer', value);
            if (value) {
                localStorage.setItem('VetCustomer', JSON.stringify(value));
            } else {
                localStorage.removeItem('VetCustomer');
            }
        },
    },
};
